<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData" />
                <div v-else>
                    <ul class="text-tip md:mt-2">
                        <li v-if="isEPolicy">
                            您已申請為電子保單，僅限此次提供紙本保單，日後辦理契約變更仍將提供電子保單。
                        </li>
                        <li>{{ policyApplyDesc }}</li>
                    </ul>

                    <div class="border-t border-gray-100 text-base mb-7 py-4 md:py-5">
                        <h4 class="text-secondary mb-2.5 font-bold">
                            請選擇欲辦理之內容
                        </h4>
                        <Radio
                            v-model:checkedValue="isApply"
                            :value="true"
                            text="保險單補發"
                            class="mb-2.5 items-baseline"
                        />
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="isApply===false || isGettingData"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getInfoB3, submitB3 } from '@/apis/B3';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
import Skeletons from '@/components/skeletons/Skeletons.vue';

export default {
    components: {
        Bottombar,
        Loading,
        Radio,
        ButtonNextService,
        Skeletons,
    },
    setup() {
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        /**
         * 正在取得資料
         */
        const isGettingData = ref(false);
        /**
         * 是否申請
         */
        const isApply = ref(false);
        const isEPolicy = ref(false);
        const isSubmitOk = ref(false);
        const isLoading = ref(false);
        const policyApplyDesc = ref(false);
        const result = computed(() => store.state.services.changeItemsResult[code]);
        // 取得api資料
        const getData = () => {
            isGettingData.value = true;
            getInfoB3().then((res) => {
                isEPolicy.value = res.data.isEPolicy === 'Y';
                policyApplyDesc.value = res.data.policyApplyDesc;
            }).finally(() => {
                isGettingData.value = false;
            });
        };
        if (!result.value) {
            getData();
        } else {
            const { storeIsApply, storeIsEPolicy } = result.value;
            isApply.value = storeIsApply;
            isEPolicy.value = storeIsEPolicy;
        }

        const saveAndgoNext = () => {
            isLoading.value = true;
            const returnData = {
                policyApplyFlag: isApply.value,
            };
            submitB3(returnData).then(() => {
                isSubmitOk.value = true;
                const value = {
                    storeIsApply: isApply.value,
                    storeIsEPolicy: isEPolicy.value,
                };
                store.dispatch('services/setChangeItemsResult', { code, value });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        return {
            isGettingData,
            isLoading,
            isSubmitOk,
            isApply,
            isEPolicy,
            policyApplyDesc,
            saveAndgoNext,
        };
    },
};
</script>
